<template>
  <div class="change-info">
    <div style="margin-top:25px;margin-left:30px;margin-bottom:45px;">
      <span
        style="font-size:24px;color:#333333;padding:5px 10px;border-right:1px #a0a0a0 solid;"
      >账户安全</span>
      <span
        style="font-size:18px;color:#333333;margin-left:5px;"
        v-if="this.changeMethod==='phoneChange'"
      >手机验证</span>
      <span
        style="font-size:18px;color:#333333;margin-left:5px;"
        v-if="this.changeMethod==='passChange'"
      >修改登陆密码</span>
    </div>
    <div class="register-head" v-if="this.changeMethod==='phoneChange'">
      <el-steps :active="active" class="phase" align-center>
        <el-step title="验证身份"></el-step>
        <el-step title="修改已验证手机"></el-step>
        <el-step title="完成"></el-step>
      </el-steps>
    </div>
    <div class="register-head" v-if="this.changeMethod==='passChange'">
      <el-steps :active="active" class="phase" align-center>
        <el-step title="验证身份"></el-step>
        <el-step title="修改登陆密码"></el-step>
        <el-step title="完成"></el-step>
      </el-steps>
    </div>
    <div
      v-if="this.changeMethod==='passChange'"
      style="width:550px;margin:0 auto;"
      class="change-loginPass"
    >
      <el-form :model="personData" ref="personData" :rules="rules" label-width="100px">
        <div class="pass-identify" v-show="active === 1&&this.through==='phone'">
          <el-form-item label="已验证手机">
            <p style="margin:0;font-size:22px;color:#333333;">{{phoneNum}}</p>
          </el-form-item>
          <el-form-item label="验证码" class="code" prop="vertifyCode">
            <el-input v-model="personData.vertifyCode" auto-complete="new-password"></el-input>
            <el-button type="primary" @click="getSmsRecords">{{getSms_button}}</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="next">下一步</el-button>
            <span
              style="color:#0a6cb1;margin-left:180px;cursor:pointer;"
              @click="handleMethodChange"
            >通过旧密码修改>></span>
          </el-form-item>
        </div>
        <div class="pass-identify" v-show="active === 1&&this.through==='password'">
          <el-form-item label="旧密码" class="old-password" prop="oldPassword">
            <el-input v-model="personData.oldPassword" placeholder="区分大小写" type="password"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="next">下一步</el-button>
            <span
              style="color:#0a6cb1;margin-left:180px;cursor:pointer;"
              @click="handleMethodChange"
            >通过验证手机号修改>></span>
          </el-form-item>
        </div>
        <div class="change-pass" v-show="active === 2">
          <el-form-item label="新密码" class="old-password" prop="newPassword">
            <el-input
              v-model="personData.newPassword"
              type="password"
              placeholder="请输入8-16位数字和字母组合，区分大小写。"
            ></el-input>
          </el-form-item>
          <el-form-item label="确认密码" class="old-password" prop="confirmPassword">
            <el-input
              v-model="personData.confirmPassword"
              type="password"
              placeholder="请与上面密码保持一致。"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="next">下一步</el-button>
          </el-form-item>
        </div>
        <div class="complete" v-show="active === 3">
          <div>
            <p style="margin:0;">
              <img src="../../../../assets/complete2.png">
            </p>
            <p class="friendly-tips">恭喜，登录密码修改成功！</p>
            <p style="font-size:16px;color:#333333;margin-bottom:45px;">3秒后将自动跳回“账户安全”。</p>
          </div>
          <el-button type="primary" @click="back">马上返回</el-button>
        </div>
      </el-form>
    </div>
    <div
      v-if="this.changeMethod==='phoneChange'"
      style="width:550px;margin:0 auto;"
      class="change-loginPass"
    >
      <el-form :model="phoneData" ref="phoneData" :rules="rules2" label-width="105px">
        <div class="phone-identify" v-show="active === 1">
          <el-form-item label="已验证手机">
            <p style="margin:0;font-size:22px;color:#333333;">{{phoneNum}}</p>
          </el-form-item>
          <el-form-item label="验证码" class="code" prop="vertifyCode2">
            <el-input v-model="phoneData.vertifyCode2"></el-input>
            <el-button type="primary" @click="getSmsRecords">{{getSms_button}}</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="next">下一步</el-button>
            <span style="color:#999999;">
              无法验证身份？请联系
              <span style="color:#0a6cb1;">400-001-2199</span>
            </span>
          </el-form-item>
        </div>
        <div class="change-phone" v-show="active === 2">
          <el-form-item label="验证手机号" class="new-phone" prop="newPhone">
            <el-input v-model="phoneData.newPhone"></el-input>
          </el-form-item>
          <el-form-item label="验证码" class="new-phone" prop="newVertifyCode">
            <el-input v-model="phoneData.newVertifyCode"></el-input>
            <el-button type="primary" @click="getSmsRecords2">{{getSms_button2}}</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="next">提交</el-button>
          </el-form-item>
        </div>
        <div class="complete" v-show="active === 3">
          <div>
            <p style="margin:0;">
              <img src="../../../../assets/complete2.png">
            </p>
            <p class="friendly-tips">恭喜，手机验证成功！</p>
            <p style="font-size:16px;color:#333333;margin-bottom:45px;">3秒后将自动跳回“账户安全”。</p>
          </div>
          <el-button type="primary" @click="back">马上返回</el-button>
        </div>
      </el-form>
    </div>
  </div>
</template>
<script>
var time;
export default {
  data() {
    const pwCheck = (rule, value, callback) => {
      if (!this.personData.newPassword) {
        callback(new Error("请输入新密码"));
      } else if (this.personData.oldPassword === this.personData.newPassword) {
        callback(new Error("新旧密码不能重复"));
      } else if (
        !/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,16}$/.test(
          this.personData.newPassword
        )
      ) {
        callback(new Error("请输入8-16位，数字和字母的组合"));
      } else {
        callback();
      }
    };
    const oldPasswordCheck = (rule, value, callback) => {
      if (this.through === "password") {
        this.$ajax
          .post(
            "/comuser-service/Account/findUpdatePassword",
            this.postData({
              id: sessionStorage.userUuid,
              usedPassword: this.personData.oldPassword
            })
          )
          .then(res => {
            if (res.code === "-10") {
              this.active = 1;
              callback(new Error(res.message));
            } else {
              callback();
            }
          });
      } else {
        callback();
      }
    }
    const SmsCheck = (rule, value, callback) => {
      if (this.active === 1 && this.changeMethod === "passChange") {
        if (value === "") {
          callback(new Error("请输入短信验证码"));
        } else {
          this.$ajax
            .post(
              "/compute-oper-service/SmsRecords/isCheckCode",
              this.postData({
                checkCode: this.personData.vertifyCode,
                mobile: sessionStorage.mobile
              })
            )
            .then(res => {
              if (res.data === 0) {
                callback();
              } else {
                callback(new Error("验证码错误"));
              }
            });
        }
      } else if (this.active === 1 && this.changeMethod === "phoneChange") {
        if (value === "") {
          callback(new Error("请输入短信验证码"));
        } else {
          this.$ajax
            .post(
              "/compute-oper-service/SmsRecords/isCheckCode",
              this.postData({
                checkCode: this.phoneData.vertifyCode2,
                mobile: sessionStorage.mobile
              })
            )
            .then(res => {
              if (res.data === 0) {
                callback();
              } else {
                callback(new Error("验证码错误"));
              }
            });
        }
      } else {
        callback();
      }
    };
    const newSmsCheck = (rule, value, callback) => {
      this.$ajax
        .post(
          "/compute-oper-service/SmsRecords/isCheckCode",
          this.postData({
            checkCode: this.phoneData.newVertifyCode,
            mobile: this.phoneData.newPhone
          })
        )
        .then(res => {
          if (res.data === 0) {
            callback();
          } else {
            callback(new Error("验证码错误"));
          }
        });
    };
    const rePwCheck = (rule, value, callback) => {
      if (
        !/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,16}$/.test(
          this.personData.newPassword
        )
      ) {
        callback(new Error("密码格式错误"));
      } else if (
        this.personData.newPassword !== this.personData.confirmPassword
      ) {
        callback(new Error("两次输入的密码不一致"));
      } else {
        callback();
      }
    }
    const checkNewPhone = (rule, value, callback) => {
      if (/^((12|13|14|15|17|18|19)[0-9]{1}\d{8})$/.test(value)) {
        callback();
      } else {
        callback(new Error("手机格式错误"));
      }
    };
    return {
      getSms_button: "获取短信验证码",
      getSms_button2: "获取短信验证码",
      time: 0,
      time2: 0,
      active: 1,
      through: "phone",
      changeMethod: "",
      phoneNum: "",
      personData: {
        vertifyCode: "",
        oldPassword: "",
        newPassword: "",
        confirmPassword: ""
      },
      phoneData: {
        vertifyCode2: "",
        newPhone: "",
        newVertifyCode: ""
      },
      rules: {
        vertifyCode: [
          // { required: true, message: "请输入短信验证码", trigger: "blur" },
          { validator: SmsCheck, trigger: "click" }
        ],
        newPassword: [
          // {required: true, message: '请输入密码', trigger: 'blur'},
          { required: true, validator: pwCheck, trigger: "blur" }
        ],
        confirmPassword: [
          { required: true, message: "请确认新密码", trigger: "blur" },
          { validator: rePwCheck, trigger: "blur" }
        ],
        oldPassword: [{ validator: oldPasswordCheck, trigger: "blur" }]
      },
      rules2: {
        vertifyCode2: [
          { required: true, message: "请输入短信验证码", trigger: "blur" },
          { validator: SmsCheck, trigger: "submit" }
        ],
        newPhone: [
          { required: true, message: "请输入验证手机号", trigger: "blur" },
          { validator: checkNewPhone, trigger: "blur" }
        ],
        newVertifyCode: [
          { required: true, message: "请输入短信验证码", trigger: "blur" },
          { validator: newSmsCheck, trigger: "submit" }
        ]
      }
    };
  },
  created() {
    this.changeMethod = this.$route.params.changeWay;
  },
  mounted() {
    this.$ajax
      .post(
        "/comuser-service/Account/seeAccount",
        this.postData({
          id: sessionStorage.userUuid
        })
      )
      .then(res => {
        var str = "";
        sessionStorage.mobile = res.data.tbAccount.mobile;
        str = sessionStorage.mobile;
        this.phoneNum = str.substr(0, 3) + "****" + str.substr(7);
      });
  },
  methods: {
    handleMethodChange() {
      if (this.through === "phone") {
        this.through = "password";
      } else {
        this.through = "phone";
      }
    },
    getSmsRecords() {
      if (this.time === 0) {
        this.time = 60;
        this.timer();
        this.$ajax
          .post(
            "/compute-oper-service/SmsRecords/addCheckCodexbkgj",
            this.postData({
              codeType: 1,
              phoneNumber: sessionStorage.mobile
            })
          )
          .then(res => {});
      }
    },
    getSmsRecords2() {
      if (this.time2 === 0) {
        this.time2 = 60;
        this.timer2();
        this.$ajax
          .post(
            "/compute-oper-service/SmsRecords/addCheckCodexbkgj",
            this.postData({
              codeType: 1,
              phoneNumber: this.phoneData.newPhone
            })
          )
          .then(res => {
            console.log("success");
          });
      }
    },
    timer() {
      if (this.time > 0) {
        this.time--;
        this.getSms_button = this.time + "s后重新获取";
        var timer = setTimeout(this.timer, 1000);
      } else if (this.time == 0) {
        this.getSms_button = "获取短信验证码";
        clearTimeout(timer);
      }
    },
    timer2() {
      if (this.time2 > 0) {
        this.time2--;
        this.getSms_button2 = this.time2 + "s后重新获取";
        var timer2 = setTimeout(this.timer2, 1000);
      } else if (this.time2 == 0) {
        this.getSms_button2 = "获取短信验证码";
        clearTimeout(timer2);
      }
    },
    next() {
      const _this = this;
      // 分页1通过手机修改，通过登陆修改。
      if (
        this.active === 1 &&
        this.through === "phone" &&
        this.changeMethod === "passChange"
      ) {
        this.$refs["personData"].validateField("vertifyCode", valid => {
          if (valid.length === 0) {
            this.active++;
          } else {
            console.log("error");
            return false;
          }
        });
      }
      // 分页1通过密码修改，通过登陆修改。
      if (
        this.active === 1 &&
        this.through === "password" &&
        this.changeMethod === "passChange"
      ) {
        // this.active++;
        // return;
        this.$refs["personData"].validateField("oldPassword", valid => {
          if (valid.length === 0) {
            this.active++;
          } else {
            console.log("error");
            return false;
          }
        });
      }
      // 分页2通过手机修改，通过登陆密码。
      if (
        this.active === 2 &&
        this.through === "phone" &&
        this.changeMethod === "passChange"
      ) {
        this.$refs["personData"].validate(valid => {
          if (valid) {
            this.$ajax
              .post(
                "/comuser-service/Account/updatesPasswordByPassWord",
                this.postData({
                  id: sessionStorage.userUuid,
                  newPassword: this.personData.newPassword
                })
              )
              .then(res => {
                this.active++;
                this.autoBack();
              });
          }
        });
      }
      if (
        this.active === 2 &&
        this.through === "password" &&
        this.changeMethod === "passChange"
      ) {
        let _this = this;
        this.$refs["personData"].validate(valid => {
          if (valid) {
            this.$ajax
              .post(
                "/comuser-service/Account/updatesPasswordByPassWord",
                this.postData({
                  id: sessionStorage.userUuid,
                  newPassword: this.personData.newPassword
                })
              )
              .then(res => {
                this.active++;
                this.autoBack();
              });
          } else {
            return false;
          }
        });
      }
      if (this.active === 1 && this.changeMethod === "phoneChange") {
        this.$refs["phoneData"].validateField("vertifyCode2", valid => {
          if (valid.length === 0) {
            this.active++;
          } else {
            console.log("error");
            return false;
          }
        });
      }
      if (this.active === 2 && this.changeMethod === "phoneChange") {
        this.$refs["phoneData"].validate(valid => {
          if (valid) {
            this.$ajax
              .post(
                "/comuser-service/Account/updateMobile",
                this.postData({
                  id: sessionStorage.userUuid,
                  mobile: this.phoneData.newPhone
                })
              )
              .then(res => {
                if ((res.code = "200")) {
                  this.active++;
                  this.autoBack();
                } else {
                  this.$message.error(res.message);
                }
              });
          }
        });
      }
    },
    autoBack() {
      this.time = setTimeout(() => {
        this.$router.push(
          "/trainClass/personalCenter/accountInfo/accountSafty"
        );
      }, 3000);
    },
    back() {
      clearTimeout(this.time);
      this.$router.push("/trainClass/personalCenter/accountInfo/accountSafty");
    }
  }
};
</script>
<style lang="scss">
.change-info {
  width: 1020px;
  border-left: 1px #dcdcdc solid;
  border-right: 1px #dcdcdc solid;
  background: rgb(255, 255, 255);
  .register-head {
    margin: 0 40px;
    padding-bottom: 25px;
    border-bottom: 1px #eeeeee solid;
    .el-step__icon {
      background-color: #dcdcdc;
      height: 30px;
      width: 30px;
      color: #ffffff;
    }
    .el-step__icon.is-text {
      border: none;
    }
    .phase {
      margin: 0 auto;
      width: 550px;
      text-align: left;
      color: #999999;
    }
    .el-step__title.is-finish,
    .el-step__title.is-process,
    .el-step__title.is-wait,
    .el-step__head.is-finish {
      color: #999999;
      border-color: #dcdcdc;
      font-weight: normal;
    }
    .el-step__line {
      background-color: #dcdcdc;
    }
    .el-step__head.is-finish .el-step__icon {
      background-color: #0a6cb1;
    }
  }
  .change-loginPass {
    .el-form-item__error {
      font-size: 16px;
      top: 40px;
    }
    .el-form-item__label {
      font-size: 16px;
      color: #333333;
    }
    .el-input {
      width: 250px;
    }
    .el-button--primary {
      background-color: #0a6cb1;
      border-color: #0a6cb1;
      padding: 12px 22px;
    }
    .pass-identify {
      margin-top: 50px;

      .old-password {
        margin-bottom: 55px;
        .el-input {
          width: 350px;
        }
      }
      .code {
        .el-button--primary {
          background-color: #eeeeee;
          border-color: #d2d2d2;
          color: #666666;
          margin-left: 10px;
          margin-bottom: 33px;
        }
      }
    }
    .change-pass {
      margin-top: 30px;
      .el-form-item__content {
        margin-top: 15px;
      }
      .el-form-item__label {
        margin-top: 15px;
      }
      .el-input {
        width: 350px;
      }
    }
  }
  .complete {
    text-align: center;
    img {
      margin: 50px 0 30px 0;
    }

    .el-button + .el-button {
      margin-left: 20px;
    }

    .friendly-tips {
      margin-left: 10px;
      font-size: 24px;
      margin: 0;
      margin-bottom: 20px;
    }
  }

  .phone-identify {
    margin-top: 50px;
    .code {
      .el-button--primary {
        background-color: #eeeeee;
        border-color: #d2d2d2;
        color: #666666;
        margin-left: 10px;
        margin-bottom: 33px;
      }
    }
  }
  .change-phone {
    width: 610px;
    margin-top: 50px;
    .el-input {
      width: 350px;
    }
    .el-button--primary {
      padding-left: 30px;
      padding-right: 30px;
    }
  }
  .new-phone {
    .el-input {
      width: 350px;
    }
    .el-button--primary {
      background-color: #eeeeee;
      border-color: #d2d2d2;
      color: #666666;
      margin-left: 5px;
      padding: 12px 22px;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/views/trainClass/personalCenter/accountInfo/changeInfo.vue